<template>
    <div class="preview">
        <div class="preview-item">
            <img src="../../../assets/images/common/certPic.jpg" ref="image" v-if="isError" />
            <img :src="url" @error="handleError" ref="image" v-else />
            <div class="preview-words">
                <h3 ref="title">{{ realName ? realName : '暂未提供' }}</h3>
                <div ref="message">
                    <p>编号No：{{ certCode ? certCode : '— —' }}</p>
                    <p>日期Date：{{ createTime ? createTime : '— —' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            url: '',
            realName: '',
            certCode: '',
            createTime: '',
            timer: null,
            isError: false
        }
    },
    methods: {
        getPreview() {
            const { url, realName, certCode, createTime } = this.$route.query
            this.url = process.env.VUE_APP_API + url
            this.realName = realName
            this.certCode = certCode
            this.createTime = createTime
        },
        setPosition() {
            let height = this.$refs.image.clientHeight || this.$refs.image.offsetWidth 
            if (!height) {
                return this.timer = setInterval(() => {
                    this.setPosition()
                }, 100)
            } else {
                clearInterval(this.timer)
                this.timer = null
            }
            this.$refs.title.setAttribute('style', `margin-top: ${height * 0.38}px;`)
            this.$refs.message.setAttribute('style', `margin-top: ${height * 0.32}px;`)
        },
        handleError() {
            this.isError = true
            this.$nextTick(() => {
                this.setPosition()
            })
        }
    },
    created() {
        this.getPreview()
    },
    mounted() {
        document.title = this.$route.meta.title
        this.setPosition()
        window.onresize = () => { this.setPosition() }
    }
}
</script>

<style scoped>
.preview {
    width: 100vw;
    height: 100vh;
    padding: 40px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
}
.preview .preview-item {
    height: 100%;
    position: relative;
    display: inline-block;
}
.preview .preview-item img {
    width: auto;
    height: 100%;
    vertical-align: middle;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}
.preview .preview-item .preview-words {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #3c3c3c;
    font-size: 18px;
    position: absolute;
    top: 0;
    left: 0;
}
.preview .preview-item .preview-words h3, 
.preview .preview-item .preview-words p {
    margin: 0;
    white-space: nowrap;
}
.preview .preview-item .preview-words h3, 
.preview .preview-item .preview-words div {
    transform: translateY(-50%);
}
.preview .preview-item .preview-words h3 {
    font-size: 35px;
    letter-spacing: 2px;
}
.preview .preview-item .preview-words p {
    margin-bottom: 15px;
}
@media screen and (max-width: 768px) {
    .preview {
        height: auto;
        min-height: 100vh;
        padding: 0.4rem 0.4rem;
    }
    .preview .preview-item {
        height: auto;
        display: flex;
        align-items: center;
    }
    .preview .preview-item img {
        width: 100%;
        height: auto;
    }
    .preview .preview-item .preview-words {
        font-size: 0.28rem;
    }
    .preview .preview-item .preview-words h3 {
        font-size: 0.6rem;
    }
    .preview .preview-item .preview-words p {
        margin-bottom: 0.25rem;
    }
}
</style>